import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da50a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "24",
  viewBox: "0 0 15 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.33333 0.75L15 11.5833L3.33333 23.25L0 19.9167L8.33333 11.5833L0 4.08333L3.33333 0.75Z",
    fill: "#5F5F5F"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = () => _ctx.clickHandler()),
    class: _normalizeClass(["frisbuy-button-arrow", [`--${_ctx.direction}`, `--${_ctx.mode}`]])
  }, _hoisted_2, 2))
}